import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useParsedQuery, createSearchParams, useAbsolutePath } from "@ploy-lib/routing";
import { useCalculationFields } from "@ploy-lib/calculation";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { commonButtonColors, commonButtonVariants } from "./ButtonCommon";
import { ButtonField } from "./Button";
import icons from "./Icons";
import { apiResourceUrl } from "@ploy-lib/core";
import { useAppLoad } from "../../appLoadContext";
import { useGTMExtended } from "../../thirdPartyScripts/GoogleTagManagerHandler";
const fields = [
    {
        namespace: "Object",
        name: "CategoryCombined",
        formName: "categoryCombined"
    },
    {
        namespace: "Object",
        name: "ObjectTypeId",
        formName: "objectTypeId"
    },
    {
        namespace: "Object",
        name: "ObjectSubTypeId",
        formName: "objectSubTypeId"
    },
    {
        namespace: "Object",
        name: "ObjectCondition",
        formName: "objectCondition"
    },
    {
        namespace: "Calculator",
        name: "ObjectPrice",
        formName: "objectPrice"
    },
    {
        namespace: "Calculator",
        name: "ObjectPriceExVat",
        formName: "objectPriceExVat"
    },
    {
        namespace: "Calculator",
        name: "EquityPercent",
        formName: "equityPercent"
    },
    {
        namespace: "Calculator",
        name: "TotalTermsCount",
        formName: "termsCount"
    },
    {
        namespace: "Calculator",
        name: "TotalTermsCountInYears",
        formName: "totalTermsCountInYears"
    }
];
const fieldDefs = fields.map(f => ({ name: f.name, namespace: f.namespace }));
export const NewTabButton = ({ muiEndIcon, pageToOpen, redirectPathKey, redirectFormContext, ...rest }) => {
    const { ext: queryParams } = useParsedQuery();
    const pushGTMEvent = useGTMExtended();
    const absolutePath = useAbsolutePath("..");
    const appLoadData = useAppLoad();
    const calculationFields = useCalculationFields(...fieldDefs);
    const [urlWithNextPage, setUrlWithNextPage] = useState();
    useEffect(() => {
        if (redirectPathKey && redirectPathKey.length > 0) {
            fetch(apiResourceUrl(`/NewTabButton/GetBasePath?key=${redirectPathKey}&product=${appLoadData.productExternalCode}`), { method: "GET" })
                .then(response => response.json())
                .then(json => {
                const content = json;
                if (!content.basePath)
                    throw new Error("Mangler basePath.");
                setUrlWithNextPage(content.basePath);
            })
                .catch(error => {
                console.error(error);
                throw new Error("En feil har oppstått.");
            });
        }
        else {
            setUrlWithNextPage(`${absolutePath}/${pageToOpen}`);
        }
    }, [
        absolutePath,
        appLoadData.productExternalCode,
        pageToOpen,
        redirectPathKey
    ]);
    const buildQueryParams = useCallback(() => {
        const fieldValues = {};
        calculationFields.forEach((field, index) => {
            const value = field?.value?.toString() ?? field?.fieldValue?.toString();
            if (typeof value !== "undefined")
                fieldValues[fields[index].formName] = value;
        });
        // Handle categoryCombined vs objectTypeId vs objectSubTypeId
        if (NoValue(fieldValues.objectTypeId) &&
            !NoValue(fieldValues.categoryCombined)) {
            const categoryCombined = fieldValues.categoryCombined.split("|");
            if (categoryCombined.length === 2) {
                // categoryCombined = {objectSubTypeId}|{objectTypeId}
                fieldValues.objectTypeId = categoryCombined[1];
                fieldValues.objectSubTypeId = categoryCombined[0];
            }
        }
        const params = {
            ext: { ...queryParams, ...fieldValues },
            formContext: undefined
        };
        if (redirectPathKey && redirectPathKey.length > 0 && pageToOpen) {
            params.ext["pageToOpen"] = pageToOpen;
        }
        if (redirectFormContext && redirectFormContext.length > 0) {
            params.formContext = redirectFormContext;
        }
        return params;
    }, [
        calculationFields,
        queryParams,
        redirectPathKey,
        pageToOpen,
        redirectFormContext
    ]);
    const onClick = useCallback(async () => {
        window.open(`${urlWithNextPage}?${createSearchParams(buildQueryParams())}`, "_blank");
        pushGTMEvent("add_to_cart");
    }, [urlWithNextPage, buildQueryParams, pushGTMEvent]);
    return (_jsx(ButtonField, { ...rest, redirectPathKey: redirectPathKey, redirectFormContext: redirectFormContext, endIcon: muiEndIcon && icons[muiEndIcon], pageToOpen: pageToOpen, onClick: onClick }));
};
function NoValue(val) {
    return val === undefined || val === null || val === "";
}
NewTabButton.displayName = "NewTabButton";
export const EditorNewTabButton = identityRecordOfFieldEditorOptions({
    NewTabButton: {
        editableOptions: {
            variant: commonButtonVariants,
            color: commonButtonColors,
            pageToOpen: true,
            redirectPathKey: true,
            redirectFormContext: true,
            muiEndIcons: Object.keys(icons)
        }
    }
});
//# sourceMappingURL=NewTabButton.js.map